// extracted by mini-css-extract-plugin
export var optionGrid = "_31-7";
export var optionList = "_31-6";
export var questionsBlock = "_31-9";
export var spacer = "_31-5";
export var stepCenteredContent = "_31-3";
export var stepInner = "_31-0";
export var stepInnerFullWidth = "_31-1";
export var stepInnerLockScroll = "_31-2";
export var stepTransitionFrame = "_31-4";
export var welcomeBlock = "_31-8";